import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  MenuItem,
  FormControl,
  Box,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    // Guardar la preferencia en localStorage
    localStorage.setItem('language', selectedLanguage);
  };

  const currentLanguage = languages.find((lang) => lang.code === (i18n.language || 'en')) || languages[0];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormControl
        variant="outlined"
        size="small"
        sx={{
          minWidth: 48,
          '& .MuiOutlinedInput-root': {
            borderRadius: '50%',
            width: 48,
            minHeight: 48,
            padding: 0,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.23)',
              borderRadius: '50%',
            },
            '&:hover fieldset': {
              borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'black',
            },
          },
        }}
      >
        <Select
          value={i18n.language || 'en'}
          onChange={handleLanguageChange}
          IconComponent={() => null}
          renderValue={(value) => {
            const selectedLang = languages.find((lang) => lang.code === value) || languages[0];
            return (
              <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
              }}>
                <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>{selectedLang.flag}</span>
                <KeyboardArrowDownIcon sx={{ fontSize: '0.875rem', color: 'black', mt: -0.25 }} />
              </Box>
            );
          }}
          sx={{
            color: 'black',
            fontSize: '0.9rem',
            height: 48,
            width: 48,
            '& .MuiSelect-select': {
              padding: 0,
              display: 'block',
              minHeight: 0,
              height: '100%',
              width: '100%',
              boxSizing: 'border-box',
              overflow: 'hidden',
              position: 'relative',
            },
            '& .MuiOutlinedInput-input': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              <span style={{ fontSize: '1.25rem' }}>{lang.flag}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;

